(function (window, document) {
  'use strict';
  if (window.YNTLeadTracking) return;
  var FIRST = 'ynt_attribution_first_v1', SESSION = 'ynt_attribution_session_v1', SENT = 'ynt_leads_sent_v1';
  var FIRST_TTL = 90 * 86400000, SESSION_TTL = 30 * 60000;
  var memorySent = {}, first, session, gaClientId = '', gaSessionId = '';
  function allowed() { try { return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; } catch (_) { return null; } }
  function storage(name) { try { return window[name]; } catch (_) { return {getItem:function(){return null;},setItem:function(){},removeItem:function(){}}; } }
  function read(storage, key) { try { return JSON.parse(storage.getItem(key) || 'null'); } catch (_) { return null; } }
  function write(storage, key, value) { try { storage.setItem(key, JSON.stringify(value)); } catch (_) {} }
  function cleanLabel(value) { value = String(value || '').slice(0, 100); return /^[a-z0-9_. -]*$/i.test(value) ? value : ''; }
  function publicPath(value) {
    try {
      var url = new URL(value, window.location.origin);
      if (!/^(www\.)?ynottony\.co\.uk$/i.test(url.hostname)) return '';
      if (/\/account|\/customer|\/checkouts?|\/orders?|\/pages\/quotes-|\/pages\/projects-quotations|\/pages\/project-submission-success/i.test(url.pathname)) return '/private';
      if (!/^\/[a-z0-9_\-/]*$/i.test(url.pathname)) return '/other';
      return url.pathname.slice(0, 100);
    } catch (_) { return ''; }
  }
  function touch() {
    var url = new URL(window.location.href), host = '';
    try { host = new URL(document.referrer).hostname.toLowerCase(); } catch (_) {}
    if (/^(www\.)?ynottony\.co\.uk$/i.test(host)) host = '';
    var source = cleanLabel(url.searchParams.get('utm_source')), medium = cleanLabel(url.searchParams.get('utm_medium'));
    source = ({ig:'instagram',fb:'facebook'})[source.toLowerCase()] || source.toLowerCase();
    var campaign = cleanLabel(url.searchParams.get('utm_campaign')), content = cleanLabel(url.searchParams.get('utm_content'));
    if (!source) {
      if (/(^|\.)google\.[a-z.]+$|(^|\.)bing\.com$|(^|\.)duckduckgo\.com$/.test(host)) { source = host; medium = 'organic'; }
      else if (/(^|\.)(instagram\.com|facebook\.com|pinterest\.[a-z.]+|pin\.it)$/.test(host)) { source = /instagram/.test(host) ? 'instagram' : /facebook/.test(host) ? 'facebook' : 'pinterest'; medium = 'social'; }
      else if (host) { source = cleanLabel(host); medium = 'referral'; }
      else { source = '(direct)'; medium = '(none)'; }
    }
    return { landing: publicPath(url.href), source: source, medium: medium || '(not set)', campaign: campaign, content: content, at: Date.now(), last: Date.now() };
  }
  function clear() {
    first = session = undefined;
    try { storage("localStorage").removeItem(FIRST); storage("sessionStorage").removeItem(SESSION); storage("localStorage").removeItem(SENT); } catch (_) {}
  }
  function refresh() {
    if (allowed() === null) return false;
    if (!allowed()) { clear(); return false; }
    var now = Date.now(), incoming = touch();
    first = read(storage("localStorage"), FIRST);
    if (!first || now - first.at > FIRST_TTL || first.at > now) { first = incoming; write(storage("localStorage"), FIRST, first); }
    session = read(storage("sessionStorage"), SESSION);
    if (!session || now - session.last > SESSION_TTL || session.last > now) session = incoming;
    session.last = now; write(storage("sessionStorage"), SESSION, session);
    return true;
  }
  function field(form, name) { var node = form.elements.namedItem(name); return node ? node.value : ''; }
  function service(form) {
    var raw = field(form, 'contact[Service type]') || field(form, 'contact[Quote page]') || field(form, 'contact[Contact Page]') || window.location.pathname;
    raw = raw.toLowerCase();
    if (/web|digital|ecommerce/.test(raw)) return 'web_design';
    if (/3d|render/.test(raw)) return '3d_rendering';
    if (/brand|logo|identity/.test(raw) && !/packag/.test(raw)) return 'brand_design';
    if (/packag|label|bottle/.test(raw)) return 'packaging_design';
    return 'design_enquiry';
  }
  function context(form) {
    return {
      first_landing_page: first.landing, first_source: first.source, first_medium: first.medium,
      session_landing_page: session.landing, enquiry_source: session.source, enquiry_medium: session.medium,
      enquiry_campaign: session.campaign, enquiry_content: session.content || '', enquiry_page: publicPath(window.location.href),
      form_type: /initial_enquiry/.test(field(form, 'ynt_form_id') || form.id) ? 'initial_enquiry' : /custom_packaging/.test(field(form, 'ynt_form_id') || form.id) ? 'detailed_quote' : 'quick_quote',
      service_category: service(form)
    };
  }
  function collectGaIdentifiers() {
    try {
      if (!allowed() || typeof window.gtag !== 'function') return;
      window.gtag('get', 'G-5P1NN0CD61', 'client_id', function (value) { if (/^\d+\.\d+$/.test(String(value || ''))) gaClientId = String(value); });
      window.gtag('get', 'G-5P1NN0CD61', 'session_id', function (value) { if (/^\d+$/.test(String(value || ''))) gaSessionId = String(value); });
    } catch (_) {}
  }
  function transportField(form, name, value) {
    var node = form.elements.namedItem(name);
    if (!value) { if (node) node.remove(); return; }
    if (!node) { node = document.createElement('input'); node.type = 'hidden'; node.name = name; node.setAttribute('data-ynt-transport', ''); form.appendChild(node); }
    node.value = value;
  }
  function attach(form) {
    try {
      if (!refresh()) {
        Array.prototype.slice.call(form.querySelectorAll('[data-ynt-attribution]')).forEach(function (node) { node.remove(); });
        form.__yntAttribution = undefined; return;
      }
      var id = field(form, 'ynt_submission_id');
      if (!form.__yntAttribution || form.__yntAttribution.id !== id) form.__yntAttribution = { id: id, data: context(form) };
      Object.keys(form.__yntAttribution.data).forEach(function (key) {
        var name = 'contact[Attribution ' + key + ']', node = form.elements.namedItem(name);
        if (!node) { node = document.createElement('input'); node.type = 'hidden'; node.name = name; node.setAttribute('data-ynt-attribution', ''); form.appendChild(node); }
        node.value = form.__yntAttribution.data[key];
      });
      collectGaIdentifiers();
      transportField(form, 'ynt_ga_client_id', gaClientId);
      transportField(form, 'ynt_ga_session_id', gaSessionId);
    } catch (_) { /* Measurement must never prevent a real enquiry. */ }
  }
  function publish(name, data) { try { if (typeof window.gtag !== 'function') return false; window.gtag('event', name, data); return true; } catch (_) { return false; } }
  function confirmed(form, response) {
    try {
      var reference = response && (response.quoteReference || (response.quote && response.quote.reference));
      if (!response || response.ok !== true || !reference || !allowed()) return;
      var sent = read(storage("localStorage"), SENT) || {};
      if (memorySent[reference] || sent[reference]) return;
      if (!form.__yntAttribution) attach(form);
      if (!form.__yntAttribution) return;
      memorySent[reference] = true;
      sent[reference] = Date.now();
      Object.keys(sent).forEach(function (key) { if (Date.now() - sent[key] > FIRST_TTL) delete sent[key]; });
      write(storage("localStorage"), SENT, sent);
      // The server sends the confirmed lead through GA4 Measurement Protocol,
      // bound to the existing Google tag's client and session identifiers.
    } catch (_) {}
  }
  document.addEventListener('visitorConsentCollected', refresh);
  document.addEventListener('click', function (event) {
    try {
      var link = event.target.closest('a[href]');
      if (!link || !refresh()) return;
      var href = link.getAttribute('href'), channel = /^mailto:/i.test(href) ? 'email' : /^tel:/i.test(href) ? 'phone' : /^https:\/\/(wa\.me|api\.whatsapp\.com)\//i.test(href) ? 'whatsapp' : '';
      if (channel) publish('ynt_contact_intent', { contact_method: channel, enquiry_page: publicPath(window.location.href), session_landing_page: session.landing, enquiry_source: session.source, enquiry_medium: session.medium });
    } catch (_) {}
  });
  window.YNTLeadTracking = { attach: attach, confirmed: confirmed };
  if (window.Shopify && window.Shopify.loadFeatures) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { if (!error) { refresh(); collectGaIdentifiers(); } });
  refresh();
  collectGaIdentifiers();
})(window, document);
